import { Outlet } from "react-router-dom";
import KBProvider from "../../Context/KBContext/KBContext";
import SearchContext from "../../Context/SearchContext/SearchContext";
import AutherProvider from "../../Context/AutherContext/AutherContext";


export const AutherRoutes = () => {
  return (
    <KBProvider>
        <AutherProvider>
            <SearchContext>
                <Outlet />
            </SearchContext>
        </AutherProvider>
    </KBProvider>
  );
}